import { useDoesUserHavePermission } from "../../../hooks/permissions";
import { useFetchClientNotesList } from "../../../hooks/queries/note";
import { UserPermisions } from "../../../utils/types/user";
import {
    formatAiWriterDateOfService,
    hasWriterContext,
    isAiSessionNotesEnabled,
} from "../helpers/aiSessionNotes";
import {
    IAiSessionNoteWriterContext,
    ISessionNote,
    NoteStatus,
    NoteTypes,
} from "../types/notes.types";

export function useAiWriterIntakeNotes(
    note: ISessionNote,
    goals: Pick<
        IAiSessionNoteWriterContext,
        "goal_one" | "goal_two" | "goal_three"
    >
) {
    const canUseAi = useDoesUserHavePermission([
        UserPermisions.CLIENT_INFO_NOTES_AI_REVIEW,
    ]);
    const isFamily =
        note.type === NoteTypes.FAMILY_SOAP_NOTE ||
        note.type === NoteTypes.FAMILY_INITIAL_SOAP_NOTE;
    const clientId = note.client?.client_id ?? "";
    const providerId = note.provider?.provider_id ?? "";
    const beforeDate = formatAiWriterDateOfService(note.date_of_service);

    return useFetchClientNotesList(
        clientId,
        {
            type: isFamily
                ? [
                      NoteTypes.FAMILY_INTAKE_NOTE,
                      NoteTypes.FAMILY_INITIAL_DIAGNOSTIC_EVALUATION,
                      NoteTypes.FAMILY_TREATMENT_REVIEW,
                  ]
                : [
                      NoteTypes.INDIVIDUAL_INTAKE_NOTE,
                      NoteTypes.INITIAL_DIAGNOSTIC_EVALUATION,
                      NoteTypes.MINOR_INTAKE_NOTE,
                      NoteTypes.MINOR_INITIAL_DIAGNOSTIC_EVALUATION,
                      NoteTypes.INDIVIDUAL_TREATMENT_REVIEW,
                  ],
            provider_id: providerId,
            load_previous_notes: true,
            before_date: beforeDate,
            status: [NoteStatus.PENDING_CODE_REVIEW, NoteStatus.CODED],
        },
        isAiSessionNotesEnabled() &&
            canUseAi &&
            !hasWriterContext({ diagnosis_codes: [], ...goals }) &&
            Boolean(clientId && providerId && beforeDate)
    );
}
